import {PaymentLinkFlow, PaymentLinkStatusType} from './types';
import {ICampaignConfiguration, ISavingsGoalConfiguration} from './v2/entities';
import {TPaymentLinkV2Type} from './v2/types';

export interface IPaymentLinkResponse {
  receiver_user: {
    id: string;
    name: string;
  };
  single_payment: boolean;
  link_consumed: boolean;
  amount?: number;
  gif?: string;
  note?: string;
}

export interface PaymentLinkModel {
  receiver_user: {
    id: string;
    name: string;
  };
  single_payment: boolean;
  link_consumed: boolean;
  amount?: number;
  gif?: string;
  note?: string;
  status: PaymentLinkStatusType;
}

export interface IFee {
  type: string;
  percentage_fee: number;
  flat_fee: number;
}

export interface IFeesResponse {
  fees: IFee[];
}

export interface FeeModel {
  fees: IFee[];
}

export interface IPublicRequestCheckoutUrl {
  amount: number;
  type: TypeOptionCheckout;
  request_money_id: string;
  risk?: IRisk;
  return_url: string;
  payer?: IPublicRequestCheckoutUrlPayer;
}

export interface IRisk {
  device_session_id: string;
}

export interface IPublicRequestCheckoutUrlPayer {
  email: string;
  phone_number?: string;
  first_name?: string;
  last_name?: string;
  address: IPublicRequestCheckoutUrlPayerAddress;
}

export interface IPublicRequestCheckoutUrlPayerAddress {
  line1: string;
  line2?: string;
  city: string;
  state: string;
  country: string;
  postal_code: string;
}

export interface IResponseCheckoutUrl {
  link: string;
}

export type TypeOptionCheckout =
  (typeof CTypeOptionCheckout)[keyof typeof CTypeOptionCheckout];

export const CTypeOptionCheckout = {
  CREDIT_CARD: 'credit',
  DEBIT_CARD: 'debit',
  APPLE_PAY: 'apple',
  GOOGLE_PAY: 'google',
  VENMO: 'venmo',
} as const;

export interface IGetCheckoutResultResponse {
  amount: number;
  amount_without_fee: number;
  created_at: string;
  status: string;
  type: string;
  receiver_user: {
    id: string;
    name: string;
  };
}

export interface ICheckoutResultResponseModel {
  amount: number;
  amount_without_fee: number;
  created_at: string;
  status: string;
  type: string;
  receiver_user: {
    id: string;
    name: string;
  };
}

export interface IPaymentLinkInformation {
  id: string;
  receiver_user: IPaymentLinkReceiver;
  information?: IPaymentLinkAdditionalInformation;
  amount?: number;
  single_payment: boolean;
  status: PaymentLinkStatusType;
  gif?: string;
  link_consumed: boolean;
}

export interface IPaymentLinkReceiver {
  id?: string;
  name?: string;
}

export interface IPaymentLinkAdditionalInformation {
  note?: string;
  gif?: string;
}

export interface IPaymentLinkOptionSelected {
  receiverName: string;
  fee: number;
  amount: number;
  type: TypeOptionCheckout;
  buttonIsDisabled: boolean;
  single_payment?: boolean;
  prefill: boolean;
}

export type PaymentInfoPayload = {
  receiver: {
    id: string;
    name: string;
  };
  single_payment: boolean;
};

export type ConfirmationTermsConditionsPayload = {
  receiver: {
    id: string;
    name: string;
  };
  single_payment: boolean;
  id: string;
  information: {
    note: boolean;
    gif: boolean;
  };
  optionSelected: {
    amount: string;
    fee: string;
    type: string;
    prefill: boolean;
  };
};

export interface IPaymentLinkV2TrackApi {
  receiver_user_id: string;
  request_money_id: string;
  flow: PaymentLinkFlow;
  payment_method: string;
  card_type?: string;
  transaction_id?: string;
  paymentSessionId?: string;
  sessionId?: string;
  paymentId?: string;
  amount?: number;
  link_type?: TPaymentLinkV2Type;
  campaign_configuration?: ICampaignConfiguration;
  savings_goal_configuration?: ISavingsGoalConfiguration;
}
